import * as React from 'react';
import { FC } from 'react';
import Box from '@mui/material/Box';
import authStore from '../store/Auth';
import { observer } from 'mobx-react';
import { Typography } from '@mui/material';
import dataStore from '../store';
import UserTopMenu from './UserTopMenu';

const companyName = 'PerseusBiomics';

const CompanyLogo: FC = observer(() => {
  return (
    <div>
      <div
        style={{
          display: 'inline-flex',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '35px',
        }}
      >
        <Box
          sx={{
            color: 'white',
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo.svg`}
            width='270px'
          />
        </Box>
        {authStore?.user?.isAuthenticated ? (
          <Box display='flex' alignItems='center'>
            <Box
              sx={{
                display: {
                  xs: 'none',
                  sm: 'block',
                  md: 'block',
                  lg: 'block',
                },
              }}
            >
              <Typography
                style={{
                  color: '#ff5f1f',
                  marginRight: '5px',
                  fontWeight: 'bold',
                }}
              >
                Credits Available: {dataStore.internalUserInfo?.credits ?? 0}
              </Typography>
            </Box>
            <UserTopMenu />
          </Box>
        ) : null}
      </div>
      <div>
        {authStore?.user?.isAuthenticated ? (
          <Box display='flex' alignItems='center'>
            <Box
              sx={{
                marginTop: '10px',
                display: {
                  xs: 'block',
                  sm: 'none',
                  md: 'none',
                  lg: 'none',
                },
              }}
            >
              <Typography
                style={{
                  color: '#ff5f1f',
                  marginRight: '5px',
                  fontWeight: 'bold',
                }}
              >
                Credits Available: {dataStore.internalUserInfo?.credits ?? 0}
              </Typography>
            </Box>
          </Box>
        ) : null}
      </div>
    </div>
  );
});

export default CompanyLogo;
